module.exports = __webpack_public_path__ + "img/icon-sb-truck-blue-color-64x48.9a4615c.svg";